// extracted by mini-css-extract-plugin
export default {"actionsWrap":"allocation-buttons_actionsWrap__i3VTG","backToGeneralButton":"allocation-buttons_backToGeneralButton__z+9d-"};